import { City } from './../../../@core/models/country.model';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { LanguageService } from 'src/app/services/language.service';
import { LanguageEnum } from '../../../shared/models/item.model';
import { UserService } from 'src/app/student/services/user.service';
import { ProfileModel } from 'src/app/student/models/user.model';
import { environment } from 'src/environments/environment';
import { ErrorHandlerService } from '../../../shared/services/error-handler.service';
import { ViewportScroller } from '@angular/common';
import { TrainingCenterService } from '../../services/training.center.service';
import { Course } from 'src/app/shared/models/course';
import { CountryService } from 'src/app/services/country.service';
import { DropDownModel } from 'src/app/@core/models/dropdown.model';
import { JobClassification } from '../../models/job-classification';
import { BreadcrumbService } from 'src/app/@core/services/breadcrumb.service';
import { IdentityService } from 'src/app/@core/services/identity.service';

Observable;
@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  id: number;
  isRtl: boolean = true;
  isInstructor: boolean;
  courses: Course[] = [];
  coursesCount: number = 4;
  toggleDescription: boolean = false;
  currentHideDescription: string = "";
  resourse = environment.userResource;
  jobDetails: JobClassification = {} as JobClassification;
  /** The profile request has come back; `notFound` covers an unknown or removed id. */
  loaded: boolean = false;
  notFound: boolean = false;
  city :DropDownModel;
  region :DropDownModel;
  country :DropDownModel;
  profileData: ProfileModel = {} as ProfileModel;

  constructor(
    private scroller: ViewportScroller,
    private _LanguageService: LanguageService,
    private route: ActivatedRoute,
    private countryService: CountryService,
    private errorHandler: ErrorHandlerService,
    private userService: UserService,
    private trainingCenterService: TrainingCenterService,
    private router: Router,
    private breadcrumbService: BreadcrumbService,
    private identityService: IdentityService,
  ) {}

  get isUnified(): boolean {
    return this.identityService.isUnifiedCode();
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);

    this.isRtl = this._LanguageService.getCurrentLanguage() === LanguageEnum.ar;
    this._LanguageService.languageChange.subscribe((result: LanguageEnum) => {
      this.isRtl = result === LanguageEnum.ar;
    });

    combineLatest([
      this.route.paramMap,
      this.route.queryParamMap,
    ]).subscribe((combined) => {
      this.id = +combined[0].get('id');
      if (this.router.url.includes('instructor')) {
        this.isInstructor = true;
        this.getProfileDetails();
      } else if(this.router.url.includes('training-center')) {
        this.isInstructor = false;
        this.getTrainingCenterDetails()
      } else {
        this.errorHandler.handleError(null);
      }
    });
  }

  goDown() {
    this.scroller.scrollToAnchor('courses');
  }
  getJobDetails(id: number): void {
    this.userService.jobDetails(id).subscribe({
      next: (result: JobClassification) => this.jobDetails = result
    });
  }

  getProfileDetails() {
    this.userService.getInstructorProfileDetails(this.id).subscribe({
      next: (data: ProfileModel) =>  
        {
          this.profileData = data
         this.updateBreadcrumb();
         this.getCityDetails(this.profileData.cityId)
         if(this.profileData.jobClassificationId != 0) this.getJobDetails(this.profileData.jobClassificationId)
        },
      error: () => this.showNotFound(),
      complete: () => {
        this.loaded = true;
        this.notFound = !this.profileData?.id;
        this.getCourses();
      }
    });
  }

  getTrainingCenterDetails() {
    this.trainingCenterService.getProfileDetails(this.id).subscribe({
      next: (data: ProfileModel) => {
        this.profileData = data;
        this.updateBreadcrumb();
      },
      error: () => this.showNotFound(),
      complete: () => {
        this.loaded = true;
        this.notFound = !this.profileData?.id;
        this.getCourses();
      }
    });
  }

  /** Unified Code breadcrumb: Home > Training centres / Instructors (route data) > the profile name. */
  private updateBreadcrumb(): void {
    if (!this.profileData?.name && !this.profileData?.nameAr) return;
    this.breadcrumbService.set([{ text: this.profileData.name, textAr: this.profileData.nameAr }]);
  }

  /** An unknown id used to render an empty skeleton with blank statistics. */
  private showNotFound(): void {
    this.profileData = {} as ProfileModel;
    this.loaded = true;
    this.notFound = true;
  }
  getRegionDetails(id: number): void {
    this.countryService.GetRegionDetails(id).subscribe((result: any) => {
      this.region = result;
      this.getCountryDetails(result.countryId);
    });
  }
  getCityDetails(cityId: number): void {
    this.countryService.GetCityDetails(cityId).subscribe((result: any) => {
      this.city = result;
      this.getRegionDetails(result.regionId);
    });
  }
  getCountryDetails(id: number): void {
    this.countryService.GetCountryDetails(id).subscribe((result: any) => {
      this.country = result;
    });
  }

  getDescription(): string {
    let description: string = "";
    
    description = this.isInstructor 
    ? (this.isRtl ? this.profileData.aboutAr : this.profileData.about)
    : (this.isRtl ? this.profileData.description : this.profileData.descriptionLang);

    if(!description) return;

    let currentDescription: string[] = description.split(" ");

    if(currentDescription?.length > 43){
      this.currentHideDescription = currentDescription.slice(43).join(" ");
      return currentDescription.slice(0, 43).join(" ");
    } else return description;
  }

  getCourses(): void {
    if(!this.profileData.courses) return;
    
    if(this.profileData.courses?.length > 4){
      this.courses = this.profileData.courses.slice(0, this.coursesCount);
    } else this.courses = this.profileData.courses;
  }

  showMoreCourses(): void {
    this.coursesCount += 4;
    this.getCourses();
  }

  hideCourses(): void {
    this.coursesCount = 4;
    this.getCourses();
  }
}
